import { useAuth } from "../utils/useAuth";
import { useNavigate } from "react-router-dom";

export default function Pending() {
  const { logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white p-6 rounded shadow text-center">
        <h2 className="text-xl font-bold mb-3">Account pending approval</h2>
        <p className="mb-4">
          Your account is awaiting approval by an administrator.
        </p>

        <button
          onClick={async () => {
            await logout();
            nav("/");
          }}
          className="text-blue-600 underline"
        >
          Back to login
        </button>
      </div>
    </div>
  );
}
